import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { MarketingService } from '../../services/marketing.service';
import * as MarketingActions from './marketing.actions';

@Injectable()
export class MarketingEffects {

  loadMarketingReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MarketingActions.loadMarketingReport),
      switchMap(({ email }) =>
        this.marketingService.getFreeMarketingReport(email).pipe(
          map(report => MarketingActions.loadMarketingReportSuccess({ report })),
          catchError(error => of(MarketingActions.loadMarketingReportFailure({ error })))
        )
      )
    )
  );

  registerLeadMagnet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MarketingActions.registerLeadMagnet),
      switchMap(({ request }) =>
        this.marketingService.registerLeadMagnet(request).pipe(
          map(response => MarketingActions.registerLeadMagnetSuccess({ response })),
          catchError(error => of(MarketingActions.registerLeadMagnetFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private marketingService: MarketingService
  ) {}
}